/* tslint:disable */
/* eslint-disable */
/**
 * Revisdom API
 * Revisdom uygulaması için REST API dokümantasyonu
 *
 * The version of the OpenAPI document: v1
 * Contact: support@revisdom.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RevisdomAPIViewModelsEntryCreateCommentRequest
 */
export interface RevisdomAPIViewModelsEntryCreateCommentRequest {
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryCreateCommentRequest
     */
    versionId?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryCreateCommentRequest
     */
    parentCommentId?: number | null;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryCreateCommentRequest
     */
    startFrame?: number;
    /**
     * 
     * @type {number}
     * @memberof RevisdomAPIViewModelsEntryCreateCommentRequest
     */
    endFrame?: number;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryCreateCommentRequest
     */
    text?: string | null;
    /**
     * 
     * @type {string}
     * @memberof RevisdomAPIViewModelsEntryCreateCommentRequest
     */
    data?: string | null;
}

/**
 * Check if a given object implements the RevisdomAPIViewModelsEntryCreateCommentRequest interface.
 */
export function instanceOfRevisdomAPIViewModelsEntryCreateCommentRequest(value: object): value is RevisdomAPIViewModelsEntryCreateCommentRequest {
    return true;
}

export function RevisdomAPIViewModelsEntryCreateCommentRequestFromJSON(json: any): RevisdomAPIViewModelsEntryCreateCommentRequest {
    return RevisdomAPIViewModelsEntryCreateCommentRequestFromJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryCreateCommentRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): RevisdomAPIViewModelsEntryCreateCommentRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'versionId': json['versionId'] == null ? undefined : json['versionId'],
        'parentCommentId': json['parentCommentId'] == null ? undefined : json['parentCommentId'],
        'startFrame': json['startFrame'] == null ? undefined : json['startFrame'],
        'endFrame': json['endFrame'] == null ? undefined : json['endFrame'],
        'text': json['text'] == null ? undefined : json['text'],
        'data': json['data'] == null ? undefined : json['data'],
    };
}

export function RevisdomAPIViewModelsEntryCreateCommentRequestToJSON(json: any): RevisdomAPIViewModelsEntryCreateCommentRequest {
    return RevisdomAPIViewModelsEntryCreateCommentRequestToJSONTyped(json, false);
}

export function RevisdomAPIViewModelsEntryCreateCommentRequestToJSONTyped(value?: RevisdomAPIViewModelsEntryCreateCommentRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'versionId': value['versionId'],
        'parentCommentId': value['parentCommentId'],
        'startFrame': value['startFrame'],
        'endFrame': value['endFrame'],
        'text': value['text'],
        'data': value['data'],
    };
}

